import Campaign from '../store/Campaign';
import { campaignStore } from '../store/store';
import { mutatorAction } from 'satcheljs';

/**
 * This method updates the cache value of Campaign objects for the Surface.
 */
export const setCampaignObjectsCache = mutatorAction(
    'setCampaignObjectsCache',
    (placementId: string, campaigns: Campaign<any>[]) => {
        campaignStore.campaignObjectsCache[placementId] = campaigns;
    }
);
